import { render, staticRenderFns } from "./GlossarySearch.vue?vue&type=template&id=1b6f816e&scoped=true&"
import script from "./GlossarySearch.vue?vue&type=script&lang=js&"
export * from "./GlossarySearch.vue?vue&type=script&lang=js&"
import style0 from "./GlossarySearch.vue?vue&type=style&index=0&id=1b6f816e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6f816e",
  null
  
)

export default component.exports